var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preset-item-view"},[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('u-tabs',[_c('u-tab',{attrs:{"route":{ name: 'presetItemCombinations' }}},[_vm._v(" Комбинации ")])],1),_c('router-view',{attrs:{"preset":_vm.preset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }